import { Firestore } from '@angular/fire/firestore';
import { Injectable } from '@angular/core';
import { User } from '@models';

import { BaseService } from '../base/base.service';

import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseService<User> {
  protected readonly documentPath = 'users';

  constructor(
    protected db: Firestore,
    protected toastService: ToastService
  ) {
    super(db, toastService);
  }
}
